import React, { useState, useRef, useEffect, useCallback } from "react";
import {
  Form,
  Input,
  Button,
  Space,
  Typography,
  Card,
  Col,
  Row,
  TimePicker,
  notification,
  DatePicker,
  Select,
  Modal,
  message,
  Popconfirm,
  Tag,
  Drawer,
  Radio,
  Upload,
  Alert,
} from "antd";
import {
  UploadOutlined,
  AimOutlined,
  DeleteOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";

import { useSelector } from "react-redux";
import "../../Visitas/style.css";
import cargarDeptosMunicipios from "../../../services/departMunic/deptosMunicipiosServices";

//Mapa
import {
  MapContainer,
  TileLayer,
  LayersControl,
  useMapEvents,
} from "react-leaflet";

import "leaflet/dist/leaflet.css";
import ImagenUploader from "./ImagenUploader";
import moment from "moment";
import FirmaCanvas from "../../firma_electronica/firma";
import {
  getAllsd_Sostenibilidad,
  getPoasSostenibilidad,
} from "../../../services/sostenibilidad/poaSosteibilidad";
import ParticipanteForm from "../participantes/FormParticipanteSostenibilidad";
import insertVisitaTecnicasostenibilidad, {
  AlmacenarSoportesVisitaTecnicasostenibilidad,
  updateVisitaTecnicaSostenibilidad,
} from "../../../services/sostenibilidad/visitaTecnicaSostenibilidad/viistaTecnicaSostenibilidadService";
import config from "../../../config";

const { Title } = Typography;
const { Option } = Select;
const { BaseLayer } = LayersControl;
const baseUrl = config.baseUrl;

const tagStyle = {
  color: "#145BAD",
  fontSize: "15px",
  fontWeight: "bold",
  padding: "8px 15px",
  borderRadius: "8px",
  textAlign: "left",
  display: "block",
  marginBottom: "15px",
  marginTop: "20px",
  width: "100%",
  wordWrap: "break-word", // Asegura que el texto se divida en múltiples líneas
  wordBreak: "break-word", // Rompe palabras largas que no caben
  whiteSpace: "normal", // Permite que el texto se ajuste en varias líneas
};

const FormularioVisitaTecnicaSostenibilidad = ({
  initialData,
  onClose,
  fetchData,
}) => {
  const [form] = Form.useForm();
  const [formParticipante] = Form.useForm();

  const [formLoaded, setFormLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const usernameFromState = useSelector((state) => state.auth.user);
  const [datosProyecto, setDatosProyecto] = useState({});
  const [modalVisible, setModalVisible] = useState(null);
  const [modalKey, setModalKey] = useState(0);

  const [codigoInternoModal, setCodigoInternoModal] = useState("");

  const [departamentosxmunicipio, setDepartamentosxmunicipio] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [departamentoSeleccionado, setDepartamentoSeleccionado] = useState("");
  const [municipios, setMunicipios] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isOtra, setIsOtra] = useState(false);

  //Estado para almacenar la lista de sd_sostenibilidad
  const [lista_sd_sostenibilidad, setLista_sd_sostenibilidad] = useState([]);

  //Estado para almacenar la lista de participantes por proyecto
  const [
    listaParticipantesSostenibilidadByProyecto,
    setListaParticipantesSostenibilidadByProyecto,
  ] = useState([]);
  const [selectedParticipants, setSelectedParticipants] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);

  const [
    dataFactoresxactividadxsubActividades,
    setDataFactoresxactividadxsubActividades,
  ] = useState([]);
  // Agregar nuevo estado para lista de factores
  const [factores, setFactores] = useState([]);

  const [selectedFactor, setSelectedFactor] = useState([]);

  // Agregar nuevo estado para lista de actividades por factor
  const [actividadesFiltradas, setActividadesFiltradas] = useState({});
  // Agregar nuevo estado para lista de subactividades por actividad
  const [subActividadesFiltradas, setSubActividadesFiltradas] = useState({});

  const [ultima_visita, setUltima_visita] = useState([]);

  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const mapRef = useRef();

  const [modoFirma, setModoFirma] = useState("anexo_firma_participantes");


    const [seleccionTitularProyecto, setSeleccionTitularProyecto] = useState(null);
      const [modalidadSesionCapacitacion, setModalidadSesionCapacitacion] =
    useState(false);

  //Inicializar el marcador del mapa
  const [markerPosition, setMarkerPosition] = useState(() => {
    if (form?.latuser && form?.lnguser) {
      return [form.latuser, form.lnguser];
    } else {
      return [4.570868, -74.297333];
    }
  });

  // Función recursiva para obtener padres con hijos finales dentro de un Factor
  const obtenerPadresConHijosFinales = (nodo) => {
    let resultados = [];

    if (nodo.children) {
      let hijosFinales = nodo.children
        .filter((child) => child.isFinal === "yes")
        .map((child) => ({
          key: child.key, // Se mantiene la clave original de la subActividad
          title: child.title,
        }));

      if (hijosFinales.length > 0) {
        resultados.push({
          key: nodo.key, // Se mantiene la clave original de la actividad
          actividad: nodo.title,
          subActividades: hijosFinales,
        });
      }

      nodo.children.forEach((child) => {
        resultados = resultados.concat(obtenerPadresConHijosFinales(child));
      });
    }

    return resultados;
  };

  // Función para estructurar la salida con Super Padres
  const obtenerSuperPadres = (data) => {
    return data.flatMap(
      (obj) =>
        obj.children?.map((factor) => ({
          key: factor.key,
          factor: factor.title,
          actividades: obtenerPadresConHijosFinales(factor),
        })) || []
    );
  };

  const handleFactorChange = async (factorKey, index) => {
    // Buscar el factor seleccionado
    const factorSeleccionado = dataFactoresxactividadxsubActividades.find(
      (factor) => factor.factor === factorKey
    );

    if (!factorSeleccionado) {
      console.error(`Factor con key ${factorKey} no encontrado.`);
      return;
    }

    // Actualizar actividades filtradas
    setActividadesFiltradas((prev) => ({
      ...prev,
      [index]: factorSeleccionado.actividades || [],
    }));

    // Limpiar subactividades filtradas
    setSubActividadesFiltradas((prev) => ({
      ...prev,
      [index]: [],
    }));

    // Resetear actividad y subActividad en el formulario
    form.setFieldsValue({
      lista_factores: form
        .getFieldValue("lista_factores")
        .map((item, i) =>
          i === index
            ? { ...item, actividad: undefined, subActividad: undefined }
            : item
        ),
    });

    // Esperar un momento para que se actualicen los estados
    await new Promise((resolve) => setTimeout(resolve, 100));
  };
  const handleActividadChange = async (actividadKey, index) => {
    if (!actividadesFiltradas[index]) {
      console.error(`No se encontraron actividades para el índice ${index}.`);
      return;
    }

    const actividadSeleccionada = actividadesFiltradas[index]?.find(
      (actividad) => actividad.actividad === actividadKey
    );

    if (!actividadSeleccionada) {
      console.error(
        `Actividad con key ${actividadKey} no encontrada en el índice ${index}.`
      );
      return;
    }

    // Actualizar subactividades filtradas
    setSubActividadesFiltradas((prev) => ({
      ...prev,
      [index]: actividadSeleccionada.subActividades || [],
    }));

    // Resetear solo el campo subActividad en el formulario
    form.setFieldsValue({
      lista_factores: form
        .getFieldValue("lista_factores")
        .map((item, i) =>
          i === index ? { ...item, subActividad: undefined } : item
        ),
    });

    await new Promise((resolve) => setTimeout(resolve, 100));
  };

  // Componente para el marcador y actualizar latitud, longitud y altitud en el formulario
  const LocationMarker = () => {
    useMapEvents({
      async click(e) {
        const { lat, lng } = e.latlng;

        // Actualizar latitud, longitud y posición del marcador
        setLatitude(lat.toFixed(6));
        setLongitude(lng.toFixed(6));
        setMarkerPosition([lat, lng]);
        form.setFieldsValue({
          latuser: lat.toFixed(6),
          lnguser: lng.toFixed(6),
        });
      },
    });

    return null; // Este componente no necesita renderizar nada visible
  };

  //Obtener datos de geolocalización or mi ubicación
  const handleLocateClick = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          // Actualizar los estados con la latitud y longitud
          const latNum = Number(latitude.toFixed(6)); // Asegúrate de que sea un número
          const lngNum = Number(longitude.toFixed(6)); // Asegúrate de que sea un número

          setLatitude(latNum);
          setLongitude(lngNum);
          setMarkerPosition([latNum, lngNum]);

          // Configurar los valores del formulario
          form.setFieldsValue({
            latuser: latNum,
            lnguser: lngNum,
          });

          const map = mapRef.current;
          if (map) {
            // Espera a que el mapa esté listo
            setTimeout(() => {
              map.flyTo([latNum, lngNum], 13); // Mover el mapa a la ubicación actual
            }, 100); // Ajusta el tiempo según sea necesario
          }
        },
        (error) => {
          console.error("Error obteniendo la ubicación:", error);
          // Puedes agregar lógica aquí para manejar el error, como mostrar un mensaje al usuario.
        }
      );
    } else {
      console.error("Geolocalización no es soportada por este navegador.");
    }
  };

  //maneja el cambio de estado del departamento
  const handleDepartamentoChange = (valor) => {
    setMunicipios([]);
    form.setFieldsValue({ municipio: undefined });
    setDepartamentoSeleccionado(valor);
    const lista_municipios = departamentosxmunicipio.find(
      (dep) => dep.nombre_departamento === valor
    );

    if (lista_municipios && lista_municipios.municipios) {
      // Ordenar la lista de municipios alfabéticamente por nombre
      const municipiosOrdenados = lista_municipios.municipios.sort((a, b) => {
        if (a.nombre_municipio < b.nombre_municipio) return -1;
        if (a.nombre_municipio > b.nombre_municipio) return 1;
        return 0;
      });

      // Actualizar el estado con la lista de municipios ordenada
      setMunicipios(municipiosOrdenados);
    } else {
      setMunicipios([]);
      form.setFieldsValue({ municipio: undefined });
    }
  };

  //Obtener lista de departamentos x municipio
  const obtenerdepartamentos = useCallback(async () => {
    try {
      setDepartamentos([]);
      form.setFieldsValue({ departamentos: [] });

      const { data } = await cargarDeptosMunicipios();
      setDepartamentosxmunicipio(data);

      let uniqueDepartamentos = data.map((departamento) => ({
        id: departamento.oid_departamento,
        nombre: departamento.nombre_departamento,
      }));

      setDepartamentos(uniqueDepartamentos);
    } catch (error) {
      console.error("Error al obtener departamentos:", error);
    }
  }, [form]);

  //Obtener lista de departamentos x municipio
  const obtenerSdSostenibilidad = useCallback(async () => {
    try {
      setLista_sd_sostenibilidad([]);

      const { data } = await getAllsd_Sostenibilidad();
      setLista_sd_sostenibilidad(data);
    } catch (error) {
      console.error("Error al obtener departamentos:", error);
    }
  }, [form]);

  // Primer useEffect para consultar API
  useEffect(() => {
    if (initialData && initialData.codigo_interno && isEditing) {
      consultarAPI(initialData.codigo_interno);
    }
  }, [initialData?.codigo_interno, isEditing]); // Solo depende de estos valores

  useEffect(() => {
    if (!datosProyecto?.poas || !Array.isArray(datosProyecto.poas)) {
      return;
    } else {
      const resultado = obtenerSuperPadres(datosProyecto.poas);

      const factoresNuevos = resultado.map((item) => ({
        key: item.key,
        factor: item.factor,
      }));

      setFactores(factoresNuevos);
      setDataFactoresxactividadxsubActividades(resultado);

      form.setFieldsValue({
        departamento: datosProyecto.departamento,
        municipio: datosProyecto.municipio,
        grupoTerritorial: datosProyecto.grupo_territorial,
        linea_productiva: datosProyecto.sector,
        codigoPREPP: datosProyecto.codigo_pre,
        nombreProyecto: datosProyecto.nombre_proyecto,
      });
    }
  }, [datosProyecto.poas]);

  // Segundo useEffect para manejar la inicialización del formulario
  useEffect(() => {
    // 1. Primero obtenemos los departamentos
    obtenerdepartamentos();

    obtenerSdSostenibilidad();
    // 2. Manejamos el estado inicial del formulario
    if (initialData && Object.keys(initialData).length > 0) {
      setModalVisible(false);
      setIsEditing(true);
      setSelectedParticipants(initialData?.participantes || []);
      setModoFirma(initialData.modoFirma || "anexo_firma_participantes");

      // Asegurar conversión segura de horaInicio y horaFin a objetos moment
      const horaInicio =
        typeof initialData.horaInicio === "string"
          ? moment(initialData.horaInicio, "hh:mm a")
          : null;

      const horaFin =
        typeof initialData.horaFin === "string"
          ? moment(initialData.horaFin, "hh:mm a")
          : null;

      const proximaSesion = initialData.proximaSesion
        ? moment(initialData.proximaSesion)
        : null;

      // Convertir fechas dentro de la lista de acuerdos de forma segura
      const acuerdos = Array.isArray(initialData.acuerdos)
        ? initialData.acuerdos.map((acuerdo) => ({
            ...acuerdo,
            fechaLimite: acuerdo?.fechaLimite
              ? moment(acuerdo.fechaLimite)
              : null,
          }))
        : [];


        // Convertir fechas dentro de la lista de entregables de forma segura
      const entregables = Array.isArray(initialData.entregables)
        ? initialData.entregables.map((entregable) => ({
            ...entregable,
            fecha_entregable: entregable?.fecha_entregable
              ? moment(entregable.fecha_entregable)
              : null,
          }))
        : [];

      const anexoFirmasValue = initialData.anexoFirmas
        ? [
            {
              uid: "-1",
              name: "anexo.pdf",
              status: "done",
              url: `${baseUrl}${initialData.anexoFirmas}`,
            },
          ]
        : []; // 👈 vacío si no existe

      form.setFieldsValue({
        ...initialData,
        horaInicio,
        horaFin,
        proximaSesion,
        acuerdos,
        entregables,
        anexoFirmas: anexoFirmasValue,
      });

      setFormLoaded(true);
    } else {
      setModalVisible(true);
      setIsEditing(false);
      // Limpiar el formulario
      form.resetFields();

      // Establecer la fecha actual
      const fechaActual = new Date().toISOString().split("T")[0];
      form.setFieldsValue({
        fecha_registro: fechaActual,
        modoFirma: "anexo_firma_participantes",
      });
    }
  }, [form, obtenerdepartamentos, initialData]); // Agregar factores como dependencia

  // Nuevo useEffect para procesar lista_factores
  useEffect(() => {
    if (initialData.lista_factores && factores.length > 0) {
      const procesarFactores = async () => {
        for (
          let index = 0;
          index < initialData.lista_factores.length;
          index++
        ) {
          const factor = initialData.lista_factores[index];

          // Primero cargar las actividades del factor
          const factorSeleccionado = dataFactoresxactividadxsubActividades.find(
            (f) => f.key === factor.factor
          );
          if (!factorSeleccionado) {
            console.error(`Factor con key ${factor.factor} no encontrado.`);
            continue;
          }

          const actividades = factorSeleccionado.actividades || [];

          // Actualizar actividades filtradas en el estado
          setActividadesFiltradas((prev) => ({
            ...prev,
            [index]: actividades,
          }));

          // Luego cargar las subactividades si hay una actividad seleccionada
          if (factor.actividad) {
            const actividadSeleccionada = actividades.find(
              (a) => a.key === factor.actividad
            );
            if (actividadSeleccionada) {
              setSubActividadesFiltradas((prev) => ({
                ...prev,
                [index]: actividadSeleccionada.subActividades || [],
              }));
            }
          }

          // Actualizar el formulario con los valores
          form.setFieldsValue({
            lista_factores: form
              .getFieldValue("lista_factores")
              .map((item, i) =>
                i === index
                  ? {
                      ...item,
                      factor: factor.factor,
                      actividad: factor.actividad,
                      subActividad: factor.subActividad,
                    }
                  : item
              ),
          });
        }
      };
      procesarFactores();
    }
  }, [
    initialData.lista_factores,
    factores,
    dataFactoresxactividadxsubActividades,
    form,
  ]);

  const agregarParticipanteLocal = async (participante) => {
    setListaParticipantesSostenibilidadByProyecto((prevLista) => [
      ...prevLista,
      participante,
    ]);
  };

  const consultarAPI = async (codigo) => {
    try {
      const data = await getPoasSostenibilidad(codigo);
      if (data) {
        setDatosProyecto(data);
        setListaParticipantesSostenibilidadByProyecto(data.participantes);

        if (!isEditing) {
          form.setFieldsValue({
            numero_visita: data.ultima_visita,
          });
          setUltima_visita(data.ultima_visita);
        }
        setModalVisible(false);
      }
    } catch (error) {
      console.error("Error en consultarAPI:", error);
      notification.error({
        message: "Error",
        description: "No se encontraron datos para el código ingresado.",
      });
      setModalVisible(true);
    }
  };

  const handleConsultar = async () => {
    try {
      if (!codigoInternoModal.trim()) {
        notification.error({
          message: "Error",
          description: "Por favor ingresa un código interno.",
        });
        return;
      }
      await consultarAPI(codigoInternoModal);
    } catch (error) {
      message.error({
        message: "Error",
        description: "No se pudo realizar la consulta. Intente nuevamente.",
      });
    }
  };

  const onFinish = async () => {
    setIsLoading(true);
    try {
      // Obtiene los valores actualizados del formulario
      const values = form.getFieldsValue();

      // Formatear horaInicio si es un objeto `moment`
      if (values.horaInicio) {
        values.horaInicio = values.horaInicio.format("hh:mm a");
      }

      // Formatear horaFin si es un objeto `moment`
      if (values.horaFin) {
        values.horaFin = values.horaFin.format("hh:mm a");
      }
      // Formatear proximaSesion si es un objeto `moment`
      if (values.proximaSesion) {
        values.proximaSesion = values.proximaSesion.format("YYYY/MM/DD");
      }
      // Formatear fechas dentro de la lista de acuerdos
      if (Array.isArray(values.acuerdos)) {
        values.acuerdos = values.acuerdos.map((acuerdo) => ({
          ...acuerdo,
          fechaLimite: acuerdo?.fechaLimite
            ? acuerdo.fechaLimite.format("YYYY/MM/DD")
            : null,
        }));
      }

            // Formatear fechas dentro de la lista de entregables
      if (Array.isArray(values.entregables)) {
        values.entregables = values.entregables.map((entregable) => ({
          ...entregable,
          fecha_entregable: entregable?.fecha_entregable
            ? entregable.fecha_entregable.format("YYYY/MM/DD")
            : null,
        }));
      }

      // Verifica si es edición o inserción y ejecuta la acción correspondiente
      if (isEditing) {
        await actualizarVisitaTecnica(values);
      } else {
        await insertarVisitaTecnica(values);
      }
    } catch (error) {
      console.error("Error al guardar la visita técnica:", error);
    } finally {
      setIsLoading(false); // Asegura que el botón se desbloquee incluso si hay un error
    }
  };

  const insertarVisitaTecnica = async (values) => {
    let clavesFirmas = [
      "fotografia_participantes",
      "fotografias_lugar",
      "fotografia_finalidad",
      "fotografia_actividad",
      "anexoFirmas",
    ];

    // Filtrar valores eliminando las claves de imágenes
    const valoresFiltrados = Object.fromEntries(
      Object.entries(values).filter(([key]) => !clavesFirmas.includes(key))
    );

    let data = {};
    try {
      const baseData = {
        ...valoresFiltrados,
        fuente: "Web",
        user_email: usernameFromState.email,
      };

      data = {
        detalle: baseData,
        numero_visita: ultima_visita,
        id_sostenibilidad: datosProyecto.id_sostenibilidad,
        tipo_envio: "Envio",
      };

      const result = await insertVisitaTecnicasostenibilidad(data); // Llamar al servicio de inserción

      if (result.status === 200) {
        notification.success({
          message: "Éxito",
          description: "Visita técnica guardada correctamente.",
        });

        // Verificar si hay soportes antes de llamar al servicio de soportes
        const tieneSoportes = clavesFirmas.some(
          (key) => values[key] && values[key].length > 0
        );

        if (tieneSoportes) {
          const respuesta = await envioSoportesVisitaTecnica(
            values,
            result.id,
            codigoInternoModal
          );
          if (respuesta.status === 200) {
            notification.success({
              message: "Éxito",
              description: "Soportes guardados correctamente.",
            });
          } else {
            notification.warning({
              message: "Advertencia",
              description:
                "Visita técnica guardada, pero no se pudieron guardar los soportes.",
            });
          }
        } else {
          notification.info({
            message: "Información",
            description: "Visita técnica guardada sin registros fotográficos.",
          });
        }

        onClose();
        fetchData();
      } else {
        notification.error({
          message: "Error",
          description: result.message,
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "No se pudo guardar la visita técnica.",
      });
    }
  };

  // Función para actualizar una novedad existente
  const actualizarVisitaTecnica = async (values) => {
    // 👉 Claves base (sin anexoFirmas ni firmas de participantes)
    let clavesFirmas = [
      "fotografia_participantes",
      "fotografias_lugar",
      "fotografia_finalidad",
      "fotografia_actividad",
    ];


    if (values.modoFirma === "anexo_firma_participantes") {
      // Agregar solo anexoFirmas
      clavesFirmas.push("anexoFirmas");
    } 

    // Filtrar valores eliminando las claves de imágenes
    const valoresFiltrados = Object.fromEntries(
      Object.entries(values).filter(([key]) => !clavesFirmas.includes(key))
    );

    let data = {};
    try {
      data = {
        ...valoresFiltrados,
        fuente: initialData.fuente,
        codigo_interno: initialData.codigo_interno,
        user_email: initialData.user_email,
      };

      const result = await updateVisitaTecnicaSostenibilidad(
        initialData.id,
        data,
        usernameFromState.email
      );

      if (result.status === 200) {
        notification.success({
          message: "Éxito",
          description: "Visita técnica actualizada correctamente.",
        });

        // Verificar si hay soportes antes de llamar al servicio de soportes
        const tieneSoportes = clavesFirmas.some(
          (key) => values[key] && values[key].length > 0
        );

        if (tieneSoportes) {
          try {
            const respuesta = await envioSoportesVisitaTecnica(
              values,
              initialData.id,
              initialData.codigo_interno
            );
            if (respuesta.status === 200) {
              notification.success({
                message: "Éxito",
                description: "Soportes actualizados correctamente.",
              });
            } else {
              notification.warning({
                message: "Advertencia",
                description:
                  "Visita técnica actualizada, pero no se pudieron actualizar los soportes.",
              });
            }
          } catch (error) {
            notification.error({
              message: "Error al enviar soportes",
              description: "No se pudieron enviar las imágenes.",
            });
          }
        } else {
          notification.info({
            message: "Información",
            description:
              "Visita técnica actualizada sin registros fotográficos.",
          });
        }

        onClose();
        fetchData();
      } else {
        notification.error({
          message: "Error",
          description: result.message,
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "No se pudo actualizar la visita técnica.",
      });
    }
  };

  // Convertir una cadena Base64 a un objeto File
  const base64ToFile = (base64String, index) => {
    const arr = base64String.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    if (!mimeMatch) {
      throw new Error("Formato Base64 incorrecto.");
    }
    const mime = mimeMatch[1];
    const extension = mime.split("/")[1]; // Extraer la extensión del archivo
    const bstr = atob(arr[1]); // Decodificar Base64
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    // Asignar un nombre único usando `Date.now()` y el índice
    const filename = `${Date.now()}-${index}.${extension}`;
    return new File([u8arr], filename, { type: mime });
  };

  async function urlToFile(url, filename) {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new File([blob], filename, { type: blob.type });
    } catch (error) {
      console.error("❌ Error al convertir url a File:", error);
      return null;
    }
  }

  const envioSoportesVisitaTecnica = async (
    values,
    id_registro,
    codigo_interno
  ) => {
    const formData = new FormData();
    formData.append("codigo_interno", codigo_interno);
    formData.append("id_visita", id_registro);
    formData.append("usuario_id", usernameFromState.email);

    const imageFields = [
      { key: "fotografia_participantes", type: "fotografia_participantes" },
      { key: "fotografias_lugar", type: "fotografias_lugar" },
      { key: "fotografia_finalidad", type: "fotografia_finalidad" },
      { key: "fotografia_actividad", type: "fotografia_actividad" },
      { key: "anexoFirmas", type: "anexoFirmas" },
    ];



    let fileIndex = 1;
    const archivos = [];

    // 🔹 Recorrer cada campo
    for (const field of imageFields) {
      if (values[field.key]) {
        // 🟢 Caso especial: anexoFirmas (Upload AntD)
        if (field.key === "anexoFirmas") {
          const fileList =
            values[field.key]?.fileList || values[field.key] || [];

          if (Array.isArray(fileList) && fileList.length > 0) {
            for (const [idx, fileObj] of fileList.entries()) {
              if (fileObj.originFileObj) {
                // Caso archivo NUEVO
                archivos.push({
                  file: fileObj.originFileObj,
                  type: field.type,
                });
              } else if (fileObj.url) {
                // Caso archivo EXISTENTE → convertir en File
                const filename = fileObj.name || fileObj.url.split("/").pop();
                const file = await urlToFile(fileObj.url, filename);

                if (file) {
                  archivos.push({ file, type: field.type });
                }
              } else {
                console.warn("⚠️ Objeto inválido en anexoFirmas:", fileObj);
              }
              fileIndex++;
            }
          }
        }

        // 🔵 Caso normal: array de imágenes base64
        else if (Array.isArray(values[field.key])) {
          for (const [idx, base64Image] of values[field.key].entries()) {
            try {
              const file = base64ToFile(base64Image, fileIndex, field.type);
              archivos.push({ file, type: field.type });
              fileIndex++;
            } catch (error) {
              console.error(
                `❌ Error al procesar imagen en ${field.key}[${idx}]:`,
                error
              );
            }
          }
        }

        // 🔵 Caso normal: un solo base64
        else {
          try {
            const file = base64ToFile(values[field.key], fileIndex, field.type);
            archivos.push({ file, type: field.type });
            fileIndex++;
          } catch (error) {
            console.error(`❌ Error al procesar ${field.key}:`, error);
          }
        }
      }
    }

    // 🔹 Si no hay archivos
    if (archivos.length === 0) {
      console.warn("⚠️ No se encontraron archivos para enviar");
      if (isEditing) {
        const formData = new FormData();
        formData.append("codigo_interno", codigo_interno);
        formData.append("id_visita", id_registro);
        formData.append("usuario_id", usernameFromState.email);
        formData.append("eliminarTodas", "true");

        try {
          return await AlmacenarSoportesVisitaTecnicasostenibilidad(formData);
        } catch (error) {
          console.error(
            "❌ Error al eliminar todas las imágenes:",
            error.response?.data || error
          );
          return {
            status: 500,
            message: "Error al eliminar todas las imágenes",
          };
        }
      }
      return { status: 200, message: "No se enviaron imágenes nuevas" };
    }

    // 🔹 Adjuntar typeFile y archivos
    const typeFileArrayOrdenado = archivos.map((item) => item.type);
    formData.append("typeFile", JSON.stringify(typeFileArrayOrdenado));

    archivos.forEach(({ file }, idx) => {
      formData.append("imagenes", file);
    });

    try {
      const response = await AlmacenarSoportesVisitaTecnicasostenibilidad(
        formData
      );
      return response;
    } catch (error) {
      console.error(
        "❌ Error al subir archivos:",
        error.response?.data || error
      );
    }
  };

  const handleCancel = () => {
    Modal.confirm({
      title: "¿Estás seguro?",
      content:
        "Si cierras, se perderán los datos diligenciados del participante.",
      onOk: () => {
        formParticipante.resetFields(); // Limpiar los campos del formulario
        setDepartamentoSeleccionado("");
        setMunicipios([]);
        setDepartamentos([]);
        setDrawerVisible(false); // Cerrar el Drawer
      },
      onCancel() {
        // No hacer nada si el usuario cancela
      },
    });
  };



  const handleSelectTitularChange = (value) => {
    // Actualizar estado
    setSeleccionTitularProyecto(value);
  };
  return (
    <div className="form-container">
      <Card className="form-card">
        <Title level={2} className="main-title">
          ACTA DE VISITA IMPLEMENTACIÓN COMPONENTE FORMACIÓN Y ACOMPAÑAMIENTO
          ESTRATEGIA DE SOSTENIBILIDAD{" "}
        </Title>
        <Form form={form} onFinish={onFinish} layout="vertical">
           <Col xs={24} sm={24}>
                  <Tag color="#D0E0F2" style={tagStyle}>
            TEMÁTICAS DE LA VISITA
          </Tag>
           </Col>
     
          <Row gutter={[16, 16]}>

            <Col xs={24} sm={24}>
              <Form.List name="lista_factores">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, fieldKey }, index) => (
                      <Space
                        key={key}
                        align="baseline"
                        className="block-display-important"
                        style={{ marginTop: 20 }}
                      >
                        <Row gutter={[16, 16]} key={key}>
                          {/* Factor */}
                          <Col xs={24} sm={8}>
                            <Form.Item
                              label="Factor"
                              name={[name, "factor"]}
                              fieldKey={[fieldKey, "factor"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Por favor seleccione un factor",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                value={selectedFactor}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                onChange={(value) => {
                                  handleFactorChange(value, index);
                                  const selectedFactor = factores.find(
                                    (item) => item.key === value
                                  );
                                  if (selectedFactor) {
                                    form.setFieldsValue({
                                      lista_factores: form
                                        .getFieldValue("lista_factores")
                                        .map((item, i) =>
                                          i === index
                                            ? {
                                                ...item,
                                                factor: selectedFactor.factor,
                                              }
                                            : item
                                        ),
                                    });
                                  }
                                }}
                              >
                                {factores.length > 0 ? (
                                  factores.map((item) => (
                                    <Option key={item.key} value={item.factor}>
                                      {item.factor}
                                    </Option>
                                  ))
                                ) : (
                                  <Option disabled>
                                    No hay factores disponibles
                                  </Option>
                                )}
                              </Select>
                            </Form.Item>
                          </Col>

                          {/* Actividad */}
                          <Col xs={24} sm={8}>
                            <Form.Item
                              label="Acción de Fortalecimiento"
                              name={[name, "actividad"]}
                              fieldKey={[fieldKey, "actividad"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Por favor seleccione una Acción de Fortalecimiento",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                onChange={(value) => {
                                  handleActividadChange(value, index);
                                  const selectedActividad =
                                    actividadesFiltradas[index]?.find(
                                      (item) => item.key === value
                                    );
                                  if (selectedActividad) {
                                    // Almacena tanto la key como la descripción
                                    form.setFieldsValue({
                                      lista_factores: form
                                        .getFieldValue("lista_factores")
                                        .map((item, i) =>
                                          i === index
                                            ? {
                                                ...item,
                                                actividad:
                                                  selectedActividad.actividad,
                                              }
                                            : item
                                        ),
                                    });
                                  }
                                }}
                              >
                                {actividadesFiltradas[index] ? (
                                  actividadesFiltradas[index].length > 0 ? (
                                    actividadesFiltradas[index].map((i) => (
                                      <Option key={i.key} value={i.actividad}>
                                        {i.actividad}
                                      </Option>
                                    ))
                                  ) : (
                                    <Option disabled value="">
                                      No hay actividades disponibles
                                    </Option>
                                  )
                                ) : (
                                  <Option disabled value="">
                                    Cargando actividades...
                                  </Option>
                                )}
                              </Select>
                            </Form.Item>
                          </Col>

                          {/* Sub Actividad */}
                          <Col xs={24} sm={7}>
                            <Form.Item
                              label="Actividad Derivada"
                              name={[name, "subActividad"]}
                              fieldKey={[fieldKey, "subActividad"]}
                              rules={[
                                {
                                  required: true,
                                  message:
                                    "Por favor seleccione una actividad derivada",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                onChange={(value) => {
                                  const selectedSubActividad =
                                    subActividadesFiltradas[index]?.find(
                                      (item) => item.key === value
                                    );
                                  if (selectedSubActividad) {
                                    // Almacena tanto la key como la descripción
                                    form.setFieldsValue({
                                      lista_factores: form
                                        .getFieldValue("lista_factores")
                                        .map((item, i) =>
                                          i === index
                                            ? {
                                                ...item,
                                                subActividad:
                                                  selectedSubActividad.title,
                                              }
                                            : item
                                        ),
                                    });
                                  }
                                }}
                              >
                                {subActividadesFiltradas[index] ? (
                                  subActividadesFiltradas[index].length > 0 ? (
                                    subActividadesFiltradas[index].map((i) => (
                                      <Option key={i.key} value={i.title}>
                                        {i.title}
                                      </Option>
                                    ))
                                  ) : (
                                    <Option disabled value="">
                                      No hay sub actividades disponibles
                                    </Option>
                                  )
                                ) : (
                                  <Option disabled value="">
                                    Cargando sub actividades...
                                  </Option>
                                )}
                              </Select>
                            </Form.Item>
                          </Col>

                          {/* Botón de eliminar */}
                          <Col
                            xs={24}
                            sm={1}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <Popconfirm
                              title="¿Está seguro de eliminarlo?"
                              okText="Sí"
                              cancelText="No"
                              onConfirm={() => remove(name)}
                            >
                              <MinusCircleOutlined />
                            </Popconfirm>
                          </Col>
                        </Row>
                      </Space>
                    ))}
                    <Form.Item>
                      <Button type="dashed" block onClick={() => add()}>
                        Agregar temática
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            {/*Campo - Fecha del registro */}
            <Col xs={24} sm={8}>
              <Form.Item label="Fecha de Registro" name="fecha_registro">
                <Input disabled />
              </Form.Item>
            </Col>

            {/*Campo - Numero de visita */}
            <Col xs={24} sm={8}>
              <Form.Item label="Numero de la visita" name="numero_visita">
                <Input disabled />
              </Form.Item>
            </Col>
            {/*Campo - Grupo territorial */}

            <Col xs={24} sm={8}>
              <Form.Item label="Grupo territorial" name="grupoTerritorial">
                <Input disabled type="text" />
              </Form.Item>
            </Col>

            {/*Campo - Departamento */}
            <Col xs={24} sm={8}>
              <Form.Item
                label="Departamento"
                name="departamento"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingresa el departamento",
                  },
                ]}
              >
                <Select disabled onChange={handleDepartamentoChange}>
                  {departamentos.map((depto) => (
                    <Option key={depto.id} value={depto.nombre}>
                      {depto.nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {/*Campo - Municipio */}
            <Col xs={24} sm={8}>
              <Form.Item
                label="Municipio"
                name="municipio"
                rules={[
                  { required: true, message: "Por favor ingresa el municipio" },
                ]}
              >
                <Select disabled>
                  {municipios.map((mun) => (
                    <Option
                      key={mun.nombre_municipio}
                      value={mun.nombre_municipio}
                    >
                      {mun.nombre_municipio}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/*Campo - Vereda */}
            <Col xs={24} sm={8}>
              <Form.Item label="Dirección exacta del proyecto" name="vereda">
                <Input />
              </Form.Item>
            </Col>

            {/*Campo - Código PRE-PP */}
            <Col xs={24} sm={12}>
              <Form.Item label="Código PRE" name="codigoPREPP">
                <Input disabled />
              </Form.Item>
            </Col>
            {/*Campo - Nombre del proyecto o iniciativa productiva */}
            <Col xs={24} sm={12}>
              <Form.Item
                label="Nombre del proyecto productivo (Actual)"
                name="nombreProyecto"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                label="Quien recibe la visita"
                name="quien_resibe_visita"
                   rules={[
                  { required: true, message: "Por favor ingresa quien resive la visita" },
                ]}
              >
                <Select
                  placeholder="Seleccionar"
                  onChange={handleSelectTitularChange}
allowClear
                >
                  <Option value="Titular del proyecto">Titular del proyecto</Option>
                  <Option value="Delegado">Delegado</Option>
                </Select>
              </Form.Item>
            </Col>


{/* Campos habilitados solo si se selecciona algo */}
        <Col xs={24} sm={12}>
          <Form.Item
            label="Nombre completo del titular o delegado del proyecto"
            name="nombre_titular_proyecto"
          >
            <Input disabled={!seleccionTitularProyecto} />
          </Form.Item>
        </Col>

       <Col xs={24} sm={12}>
  <Form.Item
    label="Número de identificación del titular o delegado"
    name="identificacion_titular_proyecto"
    rules={[{ pattern: /^\d+$/, message: "Solo se permiten números" }]}
  >
    <Input
      disabled={!seleccionTitularProyecto}
    />
  </Form.Item>
</Col>


        <Col xs={24} sm={12}>
          <Form.Item
            label="Código individuo SIRR (Si aplica)"
            name="codigo_titular_proyecto"
          >
            <Input disabled={!seleccionTitularProyecto} />
          </Form.Item>
        </Col>

            {/* Campo - Hora de Inicio */}
            <Col xs={24} sm={4}>
              <Form.Item
                label="Hora Inicio"
                name="horaInicio"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingresa la hora de inicio",
                  },
                ]}
              >
                <TimePicker format="hh:mm a" />
              </Form.Item>
            </Col>
            {/* Campo - Hora de Finalización */}
            <Col xs={24} sm={4}>
              <Form.Item
                label="Hora Finalización"
                name="horaFin"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingresa la hora de fin",
                  },
                ]}
              >
                <TimePicker format="hh:mm a" />
              </Form.Item>
            </Col>

            {/*Campo - Modalidad de sesión */}
            <Col xs={24} sm={6}>
              <Form.Item
                label="Modalidad de sesión"
                name="modalidad_sesion_capacitacion"
                rules={[
                  {
                    required: true,
                    message: "Por favor seleccione una modalidad se seción",
                  },
                ]}
              >
                <Select
                  placeholder="Seleccionar"
                  disabled={isEditing}
                  onChange={(value) => {
                    setModalidadSesionCapacitacion(value === "OTRO"); // Cambia el estado si se selecciona "Otra"
                    if (value !== "OTRO") {
                      form.setFieldsValue({
                        otra_modalidad_sesion_capacitacion: "",
                      }); // Limpiar el campo si no es "Otra"
                    }
                  }}
                >
                  <Option value="Visita técnica">Visita técnica</Option>
                  <Option value="ECA">ECA</Option>
                  <Option value="Taller">Taller</Option>
                  <Option value="Gira técnica">Gira técnica</Option>
                  <Option value="Dia de campo">Dia de campo</Option>
                  <Option value="Centros demostrativos de demostración">
                    Centros demostrativos de demostración
                  </Option>

                  <Option value="Otro">Otro</Option>
                </Select>
              </Form.Item>
            </Col>

            {/*Campo -Numero de personas en reincorporación*/}

            <Col xs={24} sm={10}>
                          <Form.Item
                            label="Numero de personas que en proceso de reincorporación "
                            name="numeroPersonasParticipan"
                            rules={[
                              { required: true, message: "Por favor seleciona una opción" },
                            ]}
                          >
                            <Select>
                              <Option value={1}>1</Option>
                              <Option value={2}>2</Option>
                              <Option value={3}>3</Option>
                              <Option value={4}>4</Option>
                              <Option value={5}>5</Option>
                              <Option value="Mas de 5">Mas de 5</Option>
                            </Select>
                          </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Tag color="#D0E0F2" style={tagStyle}>
                PUNTO DE GEOREFERENCIA
              </Tag>
            </Col>
            <Col xs={24} sm={12}>
              {/* Botón de ubicación */}
              <Button
                icon={<AimOutlined />}
                onClick={handleLocateClick}
                style={{ marginBottom: "16px" }}
              >
                Usar mi ubicación
              </Button>
              {/* Mapa - Aumentando el tamaño */}
              <div
                style={{ height: "300px", width: "100%", marginBottom: "16px" }}
              >
                <MapContainer
                  center={markerPosition}
                  zoom={13}
                  style={{ height: "100%", width: "100%" }}
                  ref={mapRef}
                >
                  <LayersControl position="topright">
                    <BaseLayer checked name="OpenStreetMap">
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                      />
                    </BaseLayer>
                    <BaseLayer name="OpenTopoMap">
                      <TileLayer
                        url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://opentopomap.org">OpenTopoMap</a> contributors'
                      />
                    </BaseLayer>
                    <BaseLayer name="OpenStreetMap H.O.T.">
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                      />
                    </BaseLayer>
                  </LayersControl>
                  <LocationMarker />
                </MapContainer>
              </div>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                name="latuser"
                label="Latitud"
                rules={[
                  { required: true, message: "Por favor ingresa la latitud" },
                ]}
              >
                <Input placeholder="Latitud" value={latitude} />
              </Form.Item>

              <Form.Item
                name="lnguser"
                label="Longitud"
                rules={[
                  { required: true, message: "Por favor ingresa la longitud" },
                ]}
              >
                <Input placeholder="Longitud" value={longitude} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Sector productivo del proyecto"
                name="linea_productiva"
              >
                <Select
                  disabled={true}
                  placeholder="Seleccionar"
                  onChange={(value) => {
                    setIsOtra(value === "Otra"); // Cambia el estado si se selecciona "Otra"
                    if (value !== "Otra") {
                      form.setFieldsValue({ otra_linea_productiva: "" }); // Limpiar el campo si no es "Otra"
                    }
                  }}
                >
                  <Option value="Agrícola">Agrícola</Option>
                  <Option value="Pecuaria">Pecuaria</Option>
                  <Option value="Servicios">Servicios</Option>
                  <Option value="Comercial">Comercial</Option>
                  <Option value="Industrial">Industrial</Option>
                  <Option value="Otra">Otra</Option>
                </Select>
              </Form.Item>
            </Col>
            {isOtra && ( // Muestra el campo adicional solo si isOtra es verdadero
              <Col xs={24} sm={12}>
                <Form.Item
                  label="Especificar otra línea productiva"
                  name="otra_linea_productiva"
                >
                  <Input placeholder="Especificar" />
                </Form.Item>
              </Col>
            )}
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={24}>
           <div style={{ marginBottom: 16 }}>
  {/* Tag como encabezado de sección */}
  <Tag
    color="#D0E0F2"
    style={
  tagStyle
    }
  >
    ACTIVIDADES DESARROLLADAS EN LA VISITA
  </Tag>

  {/* Descripción justificada con mejor legibilidad */}
  <p
    style={{
      textAlign: "justify",
      fontSize: 14,
      lineHeight: 1.6,
      margin: 0,
     fontWeight: "bolt",
    }}
  >
    Describa las actividades realizadas para cada uno de los factores de acuerdo
    con el plan de trabajo de acompañamiento y asistencia técnica aprobado.
  </p>

  {/* Línea separadora opcional */}
  <div
    style={{
      height: 1,
      backgroundColor: "#e0e0e0",
      marginTop: 12,
      marginBottom: 16,
    }}
  />
</div>


            </Col>
           
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Acompañamiento y fortalecimiento técnico y financiero"
                name="avanceFactor1"
              >
                <Input.TextArea
                  rows={4}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Fortalecimiento organizativo y asociativo"
                name="avanceFactor2"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Acompañamiento y fortalecimiento a procesos de mercadeo y comercialización"
                name="avanceFactor3"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Acompañamiento y gestión para la articulación e incidencia territorial"
                name="avanceFactor4"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Acompañamiento para la Implementación de los enfoques diferenciales"
                name="avanceFactor5"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Generación de condiciones para el acceso a tierra"
                name="avanceFactor6"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Promoción de la articulación interinstitucional para la seguridad humana en los territorios"
                name="avanceFactor7"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Acompañamiento para la implementación de los planes/programas de manejo ambiental (PMA) y el fortalecimiento de relaciones sostenibles entre seres humanos y otras formas de vida"
                name="avanceFactor8"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
          </Row>


   <Tag color="#D0E0F2" style={tagStyle}>
             ENTREGABLE PROXIMA VISITA DE LA ACTIVIDAD(S) DESARROLLADA(S)
          </Tag>
          <Form.List name="entregables">
            {(fields, { add, remove }) => (
              <>
                <Row gutter={16}>
                  <Col xs={12}>
                    <strong>Nombre entregable</strong>
                  </Col>
                  
                  <Col xs={11}>
                    <strong>Fecha de cumplimiento</strong>
                  </Col>
                  <Col xs={1}></Col>
                </Row>
                {fields.map(({ key, name, fieldKey, ...restField }) => (
                  <Row gutter={16} key={key} style={{ marginTop: "10px" }}>
                    <Col xs={12}>
                      <Form.Item
                        {...restField}
                        name={[name, "nombre_entregable"]}
                        fieldKey={[fieldKey, "nombre_entregable"]}
                      >
                        <Input placeholder="Nombre del entregable" />
                      </Form.Item>
                    </Col>
               
                    <Col xs={11}>
                      <Form.Item
                        {...restField}
                        name={[name, "fecha_entregable"]}
                        fieldKey={[fieldKey, "fecha_entregable"]}
                      >
                        <DatePicker
                          placeholder="Fecha delentregable"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={1}>
                      <Popconfirm
                        title="¿Está seguro de que desea eliminar este entregable?"
                        onConfirm={() => remove(name)}
                        okText="Sí"
                        cancelText="No"
                      >
                        <Button
                          type="link"
                          icon={<DeleteOutlined style={{ color: "red" }} />}
                        />
                      </Popconfirm>
                    </Col>
                  </Row>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block>
                    Agregar Entregable
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>




          <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Tag color="#D0E0F2" style={tagStyle}>
                HALLAZGOS
              </Tag>
            </Col>
            <Col xs={24} sm={24}>
              <Form.Item
                label="Incluir situaciones encontradas como dificultades o particularidades de las intervenciones realizadas de cualquier índole, con el fin de dejar trazabilidad de todo el proceso. Reportar posibles alertas tempranas en el presente documento con el fin de dejar la trazabilidad respectiva, así como las alternativas analizadas entre todas las partes. Reportar, si aplica, posibles casos de éxito del proyecto productivo o información relacionada que sirva a la contextualización del proceso de asistencia técnica."
                name="hallazgos"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
          </Row>


             <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Tag color="#D0E0F2" style={tagStyle}>
                RECOMENDACIONES
              </Tag>
            </Col>
            <Col xs={24} sm={24}>
              <Form.Item
                name="recomendaciones"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
          </Row>

          <Tag color="#D0E0F2" style={tagStyle}>
            ACUERDOS
          </Tag>
          <Form.List name="acuerdos">
            {(fields, { add, remove }) => (
              <>
                <Row gutter={16}>
                  <Col xs={8}>
                    <strong>Compromiso</strong>
                  </Col>
                  <Col xs={8}>
                    <strong>Responsable</strong>
                  </Col>
                  <Col xs={7}>
                    <strong>Fecha Límite</strong>
                  </Col>
                  <Col xs={1}></Col>
                </Row>
                {fields.map(({ key, name, fieldKey, ...restField }) => (
                  <Row gutter={16} key={key} style={{ marginTop: "10px" }}>
                    <Col xs={8}>
                      <Form.Item
                        {...restField}
                        name={[name, "compromiso"]}
                        fieldKey={[fieldKey, "compromiso"]}
                      >
                        <Input placeholder="Compromiso" />
                      </Form.Item>
                    </Col>
                    <Col xs={8}>
                      <Form.Item
                        {...restField}
                        name={[name, "responsable"]}
                        fieldKey={[fieldKey, "responsable"]}
                      >
                        <Input placeholder="Responsable" />
                      </Form.Item>
                    </Col>
                    <Col xs={7}>
                      <Form.Item
                        {...restField}
                        name={[name, "fechaLimite"]}
                        fieldKey={[fieldKey, "fechaLimite"]}
                      >
                        <DatePicker
                          placeholder="Fecha Límite"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={1}>
                      <Popconfirm
                        title="¿Está seguro de que desea eliminar este acuerdo?"
                        onConfirm={() => remove(name)}
                        okText="Sí"
                        cancelText="No"
                      >
                        <Button
                          type="link"
                          icon={<DeleteOutlined style={{ color: "red" }} />}
                        />
                      </Popconfirm>
                    </Col>
                  </Row>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block>
                    Agregar Acuerdo
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>

          <Row gutter={[8, 8]}>

            <Col xs={24} sm={24} md={24}>
              <Card title="ANEXO" bordered>

                <Alert
                  message="Nota"
                  description="En la lista de asistencia deberá estar incluido el titular o delegado del proyecto."
                  type="info"
                  showIcon
                  style={{ marginBottom: 16 }}
                />

                  <>
                    <Form.Item
                name="modoFirma"
                rules={[
                  {
                    required: true,
                    message: "Debe seleccionar un modo de firma",
                  },
                ]}
              >
                <Radio.Group
                  value={modoFirma}
                  onChange={(e) => {
                    setModoFirma(e.target.value);
                    form.setFieldsValue({ modoFirma: e.target.value }); // 🔑 sincronizar con Form
                  }}
                >

                  <Radio value="anexo_firma_participantes">
                    Cargar anexo de firmas
                  </Radio>

                  <Radio value="sin_anexo_firma_participantes">
                    Sin anexo
                  </Radio>
                
                </Radio.Group>
              </Form.Item>
                    {modoFirma === "anexo_firma_participantes" && (
                      <Form.Item
                        label="Subir anexo"
                        name="anexoFirmas"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => {
                          if (Array.isArray(e)) return e;
                          return e?.fileList;
                        }}
                        rules={[
                          {
                            required: true,
                            message: "Debe cargar el anexo en formato PDF",
                          },
                        ]}
                      >
                        <Upload
                          beforeUpload={(file) => {
                            const isPDF = file.type === "application/pdf";
                            if (!isPDF) {
                              message.error(
                                "Solo se permiten archivos en formato PDF"
                              );
                              return Upload.LIST_IGNORE; // evita que se agregue
                            }
                            return false; // evita subida automática, se maneja manual
                          }}
                          maxCount={1} // solo un archivo
                          accept=".pdf" // 🔹 solo permite seleccionar PDF en el diálogo
                          onChange={({ fileList }) => {
                            // 🔹 mantener solo 1 archivo (último cargado)
                            if (fileList.length > 1) {
                              fileList = [fileList[fileList.length - 1]];
                            }
                            form.setFieldsValue({ anexoFirmas: fileList });
                          }}
                        >
                          <Button icon={<UploadOutlined />}>
                            Subir archivo PDF
                          </Button>
                        </Upload>
                      </Form.Item>
                    )}
                  </>
              </Card>
            </Col>
          </Row>

          {/* Campo oculto para almacenar la selección en el formulario */}
          <Form.Item name="participantes" hidden>
            <input type="hidden" />
          </Form.Item>

          <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Tag color="#D0E0F2" style={tagStyle}>
                ANEXOS
              </Tag>
            </Col>
            <Col xs={24} sm={24}>
              <Form.Item name="fotografia_participantes">
                <ImagenUploader
                  titulo="Fotografía con buena definición del profesional de asistencia técnica con el titular del proyecto productivo/delegado"
                  onChange={(imagenesBase64) => {
                    form.setFieldsValue({
                      fotografia_participantes: imagenesBase64,
                    });
                  }}
                  value={initialData?.fotografia_participantes}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24}>
              <Form.Item name="fotografias_lugar">
                <ImagenUploader
                  titulo=" Fotografía de buena definición en el lugar donde se desarrolla el proyecto productivo (externa y interna)"
                  onChange={(imagenesBase64) => {
                    form.setFieldsValue({ fotografias_lugar: imagenesBase64 }); // Guardar la lista de imágenes en base64 en el formulario
                  }}
                  value={initialData?.fotografias_lugar}
                />
              </Form.Item>
            </Col>


            <Col xs={24} sm={24}>
              <Form.Item name="fotografia_finalidad">
                <ImagenUploader
                  titulo="Fotografía de buena definición que evidencie el funcionamiento del proyecto productivo"
                  onChange={(imagenesBase64) => {
                    form.setFieldsValue({
                      fotografia_finalidad: imagenesBase64,
                    }); // Guardar la lista de imágenes en base64 en el formulario
                  }}
                  value={initialData?.fotografia_finalidad}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24}>
              <Form.Item name="fotografia_actividad">
                <ImagenUploader
                  titulo=" Fotografía de buena definición donde se evidencie una actividad propia del proyecto productivo con el profesional de asistencia técnica"
                  onChange={(imagenesBase64) => {
                    form.setFieldsValue({
                      fotografia_actividad: imagenesBase64,
                    }); // Guardar la lista de imágenes en base64 en el formulario
                  }}
                  value={initialData?.fotografia_actividad}
                />
              </Form.Item>
            </Col>
          </Row>
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            {/* Ocultar o deshabilitar el botón de consultar si está en edición */}

            <Button
              type="primary"
              htmlType="submit"
              disabled={isLoading}
              style={{
                backgroundColor: "#52c41a",
                borderColor: "#52c41a",
              }}
            >
              {isEditing
                ? "Actualizar visita técnica"
                : "Guardar visita técnica"}
            </Button>
          </div>
        </Form>

        {/* Modal para ingresar el código SIRR */}
        <Modal
          title="Consultar código Interno"
          open={modalVisible}
          footer={null}
          closable={true}
          onCancel={() => {
            setModalVisible(false);
            onClose();
          }}
        >
          <Form onFinish={handleConsultar}>
            <Form.Item
              name="codigoInterno"
              rules={[
                {
                  required: true,
                  message: "Por favor selecciona un código interno",
                },
              ]}
            >
              <Select
                placeholder="Selecciona un código interno"
                onChange={(value) => setCodigoInternoModal(value)}
                value={codigoInternoModal}
                style={{ marginBottom: "16px" }}
                showSearch
                optionFilterProp="children"
              >
                {lista_sd_sostenibilidad.map((item) => (
                  <Select.Option key={item.oid} value={item.codigo_interno}>
                    {item.codigo_interno} - {item.implementador}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Button type="primary" htmlType="submit">
              Consultar
            </Button>
          </Form>
        </Modal>
      </Card>
    </div>
  );
};

export default FormularioVisitaTecnicaSostenibilidad;
